import React, { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams, Link, Navigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { FaArrowLeft } from "react-icons/fa";
import { testUrl } from "../BaseData";
import classes from "./GrantlarVaLoyihalar.module.css";
import GrantCard from "./GrantCard";
import { AUDIENCE_OPTIONS } from "./GrantlarVaLoyihalar";
import {
  getLabels,
  sortGrants,
  SLUG_TO_AUDIENCE,
  GRANTS_BASE,
  audiencePath,
} from "./grantUtils";

const SCOPE_OPTIONS = [
  ["international", "international"],
  ["local", "local"],
];
const SCOPE_VALUES = SCOPE_OPTIONS.map(([v]) => v);

/**
 * 2-bosqich: tanlangan bo'lim (talabalarga / oqituvchilarga / universitetlarga)
 * ichida Xalqaro/Mahalliy filtri va grant kartochkalari.
 * URL: /activity/ilmiy-faoliyat/grantlar-va-loyihalar/:kimga?turi=international|local
 */
const GrantlarRoyxat = () => {
  const { kimga } = useParams();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const L = getLabels(lang);

  const audience = SLUG_TO_AUDIENCE[kimga]; // students | teachers | universities | undefined
  const option = AUDIENCE_OPTIONS.find((o) => o.value === audience);

  const [searchParams, setSearchParams] = useSearchParams();
  const scopeParam = searchParams.get("turi");
  const scope = SCOPE_VALUES.includes(scopeParam) ? scopeParam : "international";

  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios
      .get(`${testUrl}/api/grants/`)
      .then((res) => setGrants(Array.isArray(res.data) ? res.data : []))
      .catch(() => setError(L.error))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => setToast(null), 2000);
    return () => clearTimeout(t);
  }, [toast]);

  const setScope = (value) => {
    const next = new URLSearchParams(searchParams);
    next.set("turi", value);
    setSearchParams(next, { replace: true });
  };

  const visible = useMemo(() => {
    const filtered = grants.filter(
      (g) => (g.audience === audience || g.audience === "all") && g.scope === scope
    );
    return sortGrants(filtered);
  }, [grants, audience, scope]);

  // Noto'g'ri bo'lim slug'i — bosh sahifaga
  if (!audience || !option) return <Navigate to={GRANTS_BASE} replace />;

  const { Icon } = option;

  return (
    <div className={classes.page}>
      <Link to={GRANTS_BASE} className={classes.back}>
        <FaArrowLeft /> {L.backToSections}
      </Link>

      {/* Bo'lim sarlavhasi + boshqa bo'limlarga tez o'tish */}
      <div className={classes.sectionHead}>
        <span className={classes.sectionIcon}>
          <Icon />
        </span>
        <div>
          <div className={classes.sectionKicker}>{L.pageTitle}</div>
          <h1 className={classes.sectionTitle}>{L[option.label]}</h1>
        </div>
        <div className={classes.sectionSwitch}>
          {AUDIENCE_OPTIONS.filter((o) => o.value !== audience).map((o) => (
            <Link key={o.value} to={audiencePath(o.value)} className={classes.sectionSwitchLink}>
              {L[o.label]}
            </Link>
          ))}
        </div>
      </div>

      {/* Xalqaro / Mahalliy */}
      <div className={classes.filters}>
        <div className={`${classes.filterRow} ${classes.filterRowSecondary}`}>
          {SCOPE_OPTIONS.map(([value, key]) => (
            <button
              key={value}
              type="button"
              className={`${classes.filterBtn} ${scope === value ? classes.filterBtnActive : ""}`}
              onClick={() => setScope(value)}
            >
              {L[key]}
            </button>
          ))}
        </div>
      </div>

      {loading && <div className={classes.status}>{L.loading}</div>}
      {!loading && error && <div className={classes.status}>{error}</div>}
      {!loading && !error && visible.length === 0 && (
        <div className={classes.status}>{L.empty}</div>
      )}

      {!loading && !error && visible.length > 0 && (
        <div className={classes.grid} data-aos="fade-up">
          {visible.map((item) => (
            <GrantCard key={item.id} item={item} lang={lang} onToast={setToast} />
          ))}
        </div>
      )}

      {toast && <div className={classes.toast}>{toast}</div>}
    </div>
  );
};

export default GrantlarRoyxat;
